
import {PartSelectableObject} from "./partSelOb";
import {afterBrowserRepaintDo} from "../global/globalUtils";
import {EventVerteiler} from "../global/eventVerteiler";
import {MathUtils} from "./mathUtils";
import {CONSTANTS} from "./meta_data";
import {Vector2} from "./delme_globals";
import {SelObTypes} from "./SelObTypes";
import {warnIfDebug} from "../global/logFunctions";

export class PartSelectableObjectLogo extends PartSelectableObject {
    pathToLogo;

    constructor(params) {
        super(params);
        this.handles = this.createHandles();
        this.pathToLogo = params.pathToLogo;
        this.type =SelObTypes.LOGO;
    }

    calculateCornersInLocalCanvas() {
        this.cornersInLocalCanvas = [
            new Vector2(this.margin.x, this.margin.y),
            new Vector2(this.textureSize.x-this.margin.x, this.margin.y),
            new Vector2(this.textureSize.x-this.margin.x, this.textureSize.y-this.margin.y),
            new Vector2(this.margin.x, this.textureSize.y-this.margin.y)
        ];
    }

    /**
     * Das Logo wird initialisiert, d.h. Das Bild wird geladen.
     */
    init(callback:()=>void):Promise<void> {
        const $this = this;
        return new Promise<void>((resolve)=>{
        this.setViewerTask();
        const imageObj = new Image();
        imageObj.crossOrigin = "anonymous";
        imageObj.referrerPolicy = "origin-when-cross-origin"
        imageObj.onload = function(){
            $this.imageObjectLoaded(imageObj);
            imageObj.onload = null;
            if (typeof(callback) === "function") {
                callback();
            }
            $this.viewerTaskFinished();
                resolve();
        };
        imageObj.onerror = function() {
            warnIfDebug("could not Load Logo Image " + $this.pathToLogo);
            $this.viewerTaskFinished();
            imageObj.onerror = null;
            imageObj.onload = null;
        };
            imageObj.src = $this.pathToLogo;
        })

    }
    /**
     * In init wird asynchron das Bild des Logos geladen. Hier werden nun die Daten initialisier, die wir jetzt wissen (wie Texturgröße etc)
     */
    imageObjectLoaded(imageObj:HTMLImageElement) {

        if(imageObj === null) {
            this.getParent().pendingTasks.taskFinished();
            return;
        }
        let widthImage = imageObj.width * this.parentDimensionInfos.usedScaleBecauseOfMaxTextureSize;
        let heightImage = imageObj.height * this.parentDimensionInfos.usedScaleBecauseOfMaxTextureSize;

        const maxSize = Math.max(widthImage, heightImage);
        if (maxSize > CONSTANTS.PERFORMANCE_MAX_TEXTURESIZE){
            const sizeMulti = CONSTANTS.PERFORMANCE_MAX_TEXTURESIZE / maxSize;

            widthImage = widthImage * sizeMulti;
            heightImage = heightImage * sizeMulti;
        }
        // Canvas anpassen an die Logo größe
        (this.textureCanvas as HTMLCanvasElement).width    = MathUtils.getNextPowerOfTwo(widthImage);
        (this.textureCanvas as HTMLCanvasElement).height   = MathUtils.getNextPowerOfTwo(heightImage);


        this.textureSize = new Vector2((this.textureCanvas as HTMLCanvasElement).width, (this.textureCanvas as HTMLCanvasElement).height);

        this.margin.x = ( (this.textureCanvas as HTMLCanvasElement).width   - widthImage) / 2.0;
        this.margin.y = ( (this.textureCanvas as HTMLCanvasElement).height  - heightImage) / 2.0;

        if (isNaN(this.scaling.x)) { //ist der Fall, wenn beim Initialisieren kein scaling angegeben wurde..
            if (!isNaN(this.relSize.x)) {
                // Wir haben gesagt bekommen wir groß wir sein sollen. Deswegen berechnen wir hier das absoluteScaling
                this.setScalingFromRelSize(this.relSize);
            } else {
                // Hier kommen wir an wenn wir bisher noch überhaupt kein Scaling haben. Weder relativ noch absolut.
                // Das passiert beim neu einfügen von Logos die nicht geclont sind und nicht aus der DB stammen.
                // Hier probieren wir uns eine möglichst optimale größe zu suchen.
                this.scaling = this.getScalingForTargetSize();
            }
        }
        if(this.type !== SelObTypes.PATTERN) {
            EventVerteiler.broadcast("relsizeCalculatedInViewerEvent", {id:this.id, relsize:this.getRelSize(), sizeCM:this.getSizeInCm()});
        }
        (this.textureContext2D as CanvasRenderingContext2D).drawImage(imageObj,this.margin.x,this.margin.y,widthImage,heightImage) ;

        this.calculateCornersInLocalCanvas();
        this.updateCalculatedValues();

        afterBrowserRepaintDo(()=>this.texture.needsUpdate = true);
        if (this.type !== SelObTypes.PATTERN)  {
            this.getParent().parent.utilityPainter.addSnapsForSelOb(this);
        }
        this.handlePartTransitionOnInsert();


        this.getParent().pendingTasks.taskFinished();

    }
}
